<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const isEnabled = ref(false);

const { currentAccount, updateAccount } = useAccount();

watch(
  currentAccount,
  () => {
    isEnabled.value = !!currentAccount.value?.filter_conversations_by_team;
  },
  { deep: true, immediate: true }
);

const toggleFilterConversations = async () => {
  try {
    await updateAccount({
      filter_conversations_by_team: isEnabled.value,
    });
    useAlert(t('GENERAL_SETTINGS.UPDATE.SUCCESS'));
  } catch (error) {
    useAlert(t('GENERAL_SETTINGS.UPDATE.ERROR'));
  }
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FILTER_CONVERSATIONS.LABEL')"
    :description="t('GENERAL_SETTINGS.FILTER_CONVERSATIONS.DESCRIPTION')"
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch v-model="isEnabled" @change="toggleFilterConversations" />
      </div>
    </template>
  </SectionLayout>
</template>
